import { protectedResources, loginRequest } from "../../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const getToken = (instance, account, inProgress) => {
  // Only proceed if an account is available and no authentication process is already in progress
  if (account && inProgress === "none") {
    return instance
      .acquireTokenSilent({
        scopes: protectedResources.apiHello.scopes,
        account: account,
      })
      .then((response) => {
        return response.accessToken;
      })
      .catch((error) => {
        // Session expired or consent required — redirect to login
        if (error instanceof InteractionRequiredAuthError) {
          console.warn("Silent token acquisition failed, redirecting to login");
          instance.loginRedirect(loginRequest);
          // Return a promise that never resolves since we're redirecting
          return new Promise(() => {});
        }
        console.error("Token acquisition failed", error);
        throw error;
      });
  } else {
    return new Promise((resolve, reject) => {
      reject("No account found or authentication already in progress");
    });
  }
};

export { getToken };
